import React from 'react';
import { Typography, Link } from '@mui/material';
import { Lightbulb } from '@mui/icons-material';
import { getPageRoute } from 'src/services';
import HighlightCard from 'src/components/blocks/HighlightCard.js';

const GoogleCalendarUpsell = () => {
  return (
    <HighlightCard>
      <Lightbulb sx={{ fontSize: 18, mt: 0.1, zIndex: 1 }} />
      <Typography variant="body1" sx={{ zIndex: 1 }}>
        Try{" "}
        <Link 
          href={getPageRoute("help", "SUBSCRIBING_GOOGLE_CALENDAR_STEPS")}
          sx={{ cursor: "pointer", textDecoration: "underline", fontWeight: 600 }}
        >
          Google Connect
        </Link>
        {" "}that uses Google Calendar's API to push events directly to your calendar across <b>all your devices</b>. No waiting, no delays.
        <br /><br />
        <Link 
          href={getPageRoute("help", "SUBSCRIBING_GOOGLE_CALENDAR_STEPS")}
          sx={{ cursor: "pointer", textDecoration: "underline" }}
        >
          Learn more here
        </Link>
        .
      </Typography>
    </HighlightCard>
  );
};

export default GoogleCalendarUpsell;